// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"93":"c116b09f","594":"e04c204c","645":"35ace773","864":"b1f47929"}[chunkId] + ".js";
};